// facets-custom.js

openCustomFacetLink = (event, pathname) => {
    event.preventDefault();
    
    const currentUrl = new URL(window.location.href);
    const currentPath = currentUrl.pathname;
    
    // Check if we're on /collections/all with tags in the path
    const collectionsAllMatch = currentPath.match(/^\/collections\/all\/(.+)$/);
    
    if (collectionsAllMatch && pathname.includes('/collections/all/')) {
        // Extract existing tags from current URL
        const existingTags = collectionsAllMatch[1];
        
        // Extract new tag from the pathname
        const newTagMatch = pathname.match(/\/collections\/all\/(.+)$/);
        if (newTagMatch) {
            const newTag = newTagMatch[1];
            
            // Check if the new tag is already in the existing tags
            const existingTagsArray = existingTags.split('+');
            if (!existingTagsArray.includes(newTag)) {
                // Append new tag with +
                const updatedPath = `/collections/all/${existingTags}+${newTag}`;
                currentUrl.pathname = updatedPath;
                window.location.href = currentUrl.href;
                return;
            } else {
                // Tag already exists, remove it (toggle behavior)
                const filteredTags = existingTagsArray.filter(tag => tag !== newTag);
                if (filteredTags.length > 0) {
                    const updatedPath = `/collections/all/${filteredTags.join('+')}`;
                    currentUrl.pathname = updatedPath;
                    window.location.href = currentUrl.href;
                } else {
                    // No tags left, go to base /collections/all
                    currentUrl.pathname = '/collections/all';
                    window.location.href = currentUrl.href;
                }
                return;
            }
        }
    }
    
    // Default behavior: replace pathname
    currentUrl.pathname = pathname;
    window.location.href = currentUrl.href;
}
